.strip {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
  flex-wrap: wrap;
}

.slotGroup {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.insertedChip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(4.5rem * 0.75);
  min-height: 5rem;
  padding: var(--tuna-spacing-2);
  border-left: 1px dashed var(--tuna-color-border);
  border-right: 1px dashed var(--tuna-color-border);
  border-top: 0;
  border-bottom: 0;
  background: transparent;
  cursor: pointer;
}

.insertedTag {
  font-size: var(--tuna-fontsize-xs);
  color: var(--tuna-color-text-tertiary);
}

.insertedName {
  font-size: var(--tuna-fontsize-md);
  font-weight: 500;
}
